<div class="tableros_container">
    <h2>Tableros BI</h2>

    <iframe
        width="1400"
        height="900"
        src="https://app.powerbi.com/view?r=eyJrIjoiZjc0OTExZjktZTc2OC00NjQ5LWE0OGQtNjVmY2MwODU4ZjlhIiwidCI6IjQ0ZTY0NWRmLWFhMjAtNDVlNi04MGM4LWRmMGQxYTYwMDdmMyJ9"
        frameborder="0"
        allowFullScreen="true"></iframe>
</div>
